import { Injectable } from '@angular/core';
import { get, set } from 'idb-keyval';
import { ConsumerJob, ConsumerJobClient, EntityBase, Job, VendorJob, VendorJobClient } from './nswag/nswagclient';
import { firstValueFrom } from 'rxjs';
import { TelemetryService } from './telemetry.service';

type JobDictionary<T extends EntityBase> = { [key: string]: T } 

@Injectable({
  providedIn: 'root'
})
export class JobCacheService {
  static cache_key: string = "cache_key_2"
  constructor(private _vendorJobClient : VendorJobClient, private _consumerJobClient:ConsumerJobClient, private telemetry: TelemetryService) {
    //console.log("JobCacheService constructor");

  }
  private vendorJobsForVendorCompanyKey(userCompanyId:string):string{
    return JobCacheService.cache_key+"vendorJobsForVendorCompany"+userCompanyId;
  }
  private consumerJobsKeyForConsumerCompany(consumerCompanyId:string):string{
    return JobCacheService.cache_key+"consumerJobs"+consumerCompanyId;
  }
  async getVendorJobsForVendorCompany(userCompanyId:string):Promise<VendorJob[]>{
    //console.log("getVendorJobsForVendorCompany", userCompanyId);
    let cached = await get<JobDictionary<VendorJob>>(this.vendorJobsForVendorCompanyKey(userCompanyId)) || {};
    var newest = JobCacheService.newest(Object.values(cached));

    var countRequest = this._vendorJobClient.getVendorJobsForVendorCompanyCount(userCompanyId);

    const servicefoundVendorJobs = await firstValueFrom(this._vendorJobClient.getVendorJobsForVendorCompany(userCompanyId, newest));
    let all = JobCacheService.AddTo(cached, servicefoundVendorJobs);

    var serviceCount = await firstValueFrom(countRequest);
    if (serviceCount !== Object.values(all).length) {
      console.info("cached vendor did not equal service count", serviceCount, Object.values(all).length);
      this.telemetry.trackTrace({ message: "cached did not equal service count for vendor jobs", severityLevel: 2 });
      var jobsReload = await firstValueFrom(this._vendorJobClient.getVendorJobsForVendorCompany(userCompanyId, null));
      all = JobCacheService.AddTo({}, jobsReload);
    }

    set(this.vendorJobsForVendorCompanyKey(userCompanyId), all);
    return Object.values(all);
  }

  async getConsumerJobs(consumerCompanyId:string):Promise<ConsumerJob[]>{
   ///// console.log("getConsumerJobs");
    let cached = await get<JobDictionary<ConsumerJob>>(this.consumerJobsKeyForConsumerCompany(consumerCompanyId)) || {};
    var newest = JobCacheService.newest(Object.values(cached));

    var countRequest = this._consumerJobClient.getConsumerJobsCount(consumerCompanyId);

    const servicefoundVendorJobs = await firstValueFrom(this._consumerJobClient.getConsumerJobs(consumerCompanyId,newest));
    let all = JobCacheService.AddTo(cached, servicefoundVendorJobs);

    var serviceCount = await firstValueFrom(countRequest);

    if (serviceCount !== Object.values(all).length) {
      console.info("cached consumer did not equal service count", consumerCompanyId, serviceCount, Object.values(all).length);
      this.telemetry.trackTrace({ message: "cached consumer did not equal service count", severityLevel: 2 });
      var jobsReload = await firstValueFrom(this._consumerJobClient.getConsumerJobs(consumerCompanyId, null));
      all = JobCacheService.AddTo({}, jobsReload);
    }

    set(this.consumerJobsKeyForConsumerCompany(consumerCompanyId), all);
    return Object.values(all);
  }

  static AddTo<T extends EntityBase>(jobs:JobDictionary<T>, newJobs:T[]) : JobDictionary<T>{
    for (const job of newJobs) {
      if (job.id) {
        jobs[job.id] = job;
      }
    }
    return jobs;
  }
  static newest(jobs:EntityBase[]) : Date{
    let newest = new Date(1990,1).getTime();
    for(let job of jobs){
      if (job.modified.getTime() > newest){
        newest = job.modified.getTime();
      }
    }
    return new Date(newest);
  }
  
}
